import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { validString, decimal, date, dateRange, surcharge } from "Components/shared/helpers/validations";

const maxDimension = Yup.object().shape(reverseShape({
    length: decimal.required(),
    width: decimal.required(),
    height: decimal.required()
}));

export const SpecialConditionCareSchema = Yup.object().shape(
    reverseShape({
        settingID: validString.optional(),
        name: validString.required(),
        maxWeight: decimal.required(),
        surcharge: surcharge,
        validFrom: date.required(),
        validTo: date.required().concat(dateRange),
        maxDimension: maxDimension.required()
    })
);